import React, { Component } from "react";
class ImportantNotice extends Component {
  render() {
    return (
      <div className="important-notice">
        <div className="container p-0">
          <div className="col-md-12 p-0">
            <h3><span className="important-bold">Important</span> Notice</h3>
            <p>
              <span className="num-bold">1.</span>
              <span> NEFT transactions will be available 24x7 on Internet (Corporate &amp; Retail) and Mobile Banking Channels w.e.f. 16th December 2019 as per details given below:<br />
                From 8.00 AM to 6.30 PM – As per customer approval limit<br />
                From 6.30 PM to 8.00 AM (including 2nd &amp; 4th Saturday, Sunday &amp; RTGS Holidays) – Less than INR 1 Crore (Transactions which are INR 1 Crore or above will be processed on the next RTGS day)
              </span>
            </p>
            <p>
              <span className="num-bold">2.</span>
              <span> For fund transfer to other banks on 2nd and 4th Saturdays, you can use the IMPS service, which is available 24*7. </span>
            </p>
            <p>
              <span className="num-bold">3.</span>
              <span> To locate Aadhaar Enrolment Centres
                <a className="ms-1" href="https://www.axis.bank.in/docs/default-source/default-document-library/axis-bank_aadhaar-enrolment-centres.pdf?sfvrsn=4" title="Download List of centers" download="download" target="_blank" rel="noopener noreferrer">click here</a>
              </span>
            </p>
            <p>
              <span className="num-bold">4.</span>
              <span> For our international branch locations
                <a className="ms-1" href="https://branch.axis.bank.in/?type=overseas-presence">click here</a> .<br />
              </span>
            </p>
          </div>
        </div>
      </div>
    );
  }
}
export default ImportantNotice;
